/**
 * 非同期通信用ストア
 * Comspostion API で記述すること
 */
"use strict";
import axiosBase from "axios";
import { AxiosError, AxiosResponse } from "axios";

import router from "../router";

console.log("axios plugin");

let baseURL;
//注意:env-store にも同様の分岐があるが、env-storeとの共通化はできないので変更時は両方メンテナンスすること
if (location.hostname === "127.0.0.1" || location.hostname === "localhost") {
  if (location.port === "8081") {
    // ローカル開発環境
    baseURL = "http://localhost:8080/cage/";
  } else {
    // ステージング開発環境
    baseURL = "/cage/";
  }
} else {
  //本番環境
  baseURL = "";
}

const _axios = axiosBase.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
    "Access-Control-Allow-Origin": "*",
  },
  //認証用クッキーも渡す
  withCredentials: true,
  // プロキシを無視する設定
  proxy: false,

  responseType: "json",
});

_axios.interceptors.response.use(
  (response: AxiosResponse) => {
    console.log("共通レスポンス処理");
    return response;
  },
  (error: AxiosError) => {
    //ユーザー情報取得以外の401は例外処理を行なう
    //ユーザー取得は個別ハンドリング
    if (
      error.status === 401 &&
      error.config &&
      error.config.url !== "user/info" &&
      error.config.url !== "/cage/user/info"
    ) {
      console.log("error.config.url", error.config.url);
      router.replace("/auth");
      throw new Error("認証エラー");
    }
    // エラーのアラートを表示
    console.log("共通エラー処理");
    //
    return Promise.reject(error);
    //throw new Error("API error.");
    //return { data: { data: { records: [] } } };
  }
);

export default _axios;
